import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './locales/en.json';
import ru from './locales/ru.json';

const savedLang = localStorage.getItem('app_language');
const userLang = window.Telegram?.WebApp?.initDataUnsafe?.user?.language_code || 'en';
const russianFriendly = ['ru', 'uk', 'by', 'kz', 'uz', 'tj'];
const detectedLang = russianFriendly.includes(userLang) ? 'ru' : 'en';
const initialLang = savedLang || detectedLang;

i18n
	.use(initReactI18next)
	.init({
		resources: {
			en: { translation: en },
			ru: { translation: ru }
		},
		lng: initialLang,
		fallbackLng: 'en',
		interpolation: {
			escapeValue: false
		}
	});

export default i18n;


//  "currency_one": "token",
//   "currency_few": "tokens",
//   "currency_many": "tokens",
//   "currency_short": "tok.",
//   "currency_some": "tokens",
//   "currency_title": "Tokens",
//   "buyTokens": "Buy {{currency}}"

// "currency_one": "токен",
//   "currency_few": "токена",
//   "currency_many": "токенов",
//   "currency_some": "токены",
//   "currency_short": "ток.",
//   "currency_title": "Токены",
//   "buyTokens": "Купить {{currency}}"